export const CLIENT_TYPES_KEY = 'zobu_client_types';

export interface ClientTypeItem {
  id: string;
  icon: string;
  label: string;
  desc: string;
  order: number;
}

export const mockClientTypes: ClientTypeItem[] = [
  { id: 'ct-1', icon: 'ri-map-2-line', label: 'Regional Development Agencies', desc: 'BEBKA, OKA, Ankara DA: strategy, clustering and EU policy alignment', order: 1 },
  { id: 'ct-2', icon: 'ri-government-line', label: 'Metropolitan Municipalities', desc: 'İzmir and other cities: development plans, investment climate, feasibility', order: 2 },
  { id: 'ct-3', icon: 'ri-building-4-line', label: 'Industrial Corporations', desc: 'TÜPRAŞ and sector leaders: seismic risk, CAPEX estimation, engineering advisory', order: 3 },
  { id: 'ct-4', icon: 'ri-global-line', label: 'International Organisations', desc: 'IFC / World Bank Group, AHK Türkei: market intelligence, investment advisory', order: 4 },
  { id: 'ct-5', icon: 'ri-leaf-line', label: 'Agri-Food Value Chains', desc: 'Producer associations and agencies: value chain analysis, export strategy, GI branding', order: 5 },
  { id: 'ct-6', icon: 'ri-rocket-line', label: 'Private Sector & Ventures', desc: 'Holdings, SMEs and growth-stage ventures: strategy, transformation, market entry', order: 6 },
];

export const CLIENT_TYPE_ICON_OPTIONS = [
  'ri-map-2-line', 'ri-government-line', 'ri-building-4-line', 'ri-global-line',
  'ri-leaf-line', 'ri-rocket-line', 'ri-bank-line', 'ri-hospital-line',
  'ri-team-line', 'ri-briefcase-4-line', 'ri-store-2-line', 'ri-community-line',
  'ri-building-2-line', 'ri-shield-check-line', 'ri-award-line', 'ri-earth-line',
  'ri-factory-line', 'ri-plant-line', 'ri-sun-line', 'ri-recycle-line',
  'ri-graduation-cap-line', 'ri-heart-pulse-line', 'ri-flight-takeoff-line', 'ri-ship-line',
];
